import React from 'react';

export default function Input(props) {
  const hasError = Boolean(props.errorMessage);
  const isFilled = !props.disabled && props.value?.length >= 1;

  const handleChange = e => {
    props.handleChange?.(e);
  };

  const handleBlur = e => {
    props.handleBlur?.(e);
  };

  return (
    <div
      className={`form-input ${props.className} ${
        isFilled && 'form-input--filled'
      } ${props.button && 'form-input--button'}`}
    >
      <input
        className={`form-input__field ${
          isFilled || props.className.includes('form-input__field--filled')
            ? 'form-input__field--filled'
            : ''
        }`}
        id={props.id}
        name={props.name}
        disabled={props.disabled}
        type={props.type || 'text'}
        value={props.value}
        required={props.required}
        {...props.fieldProps}
        onChange={handleChange}
        onKeyDown={props.onKeyDown}
        placeholder={props.placeholder || ''}
        onBlur={handleBlur}
        inputMode={props.inputMode}
      />
      {props.clearBtn && (
        <button
          aria-label={props.labelClear}
          className="form-input__icon-wrapper form-input__clear-btn"
          onClick={props.clearClickHandler}
          type="button"
          disabled={props.buttonDisabled || !isFilled}
        >
          <svg
            viewBox="0 0 120 120"
            className="form-input__icon form-input__icon-close"
            width="24"
            height="24"
            role="presentation"
          >
            <use xlinkHref="#close-regular"></use>
          </svg>
        </button>
      )}
      {props.button && (
        <button
          aria-label={props.buttonLabel}
          disabled={props.buttonDisabled || !isFilled}
          className={`btn siplast--sg btn--primary ${props.buttonClassName}`}
          onClick={props.buttonClickHandler}
          type="button"
        >
          {props.buttonLabel}
        </button>
      )}
      <label className="form-input__label" htmlFor={props.id}>
        {props.label}
      </label>
      <div className="form-input__icon-wrapper">
        <svg
          viewBox="0 0 120 120"
          className="form-input__icon form-input__icon-check"
          width="22"
          height="22"
          role="presentation"
        >
          <use xlinkHref="#checkmark-regular" />
        </svg>
        <svg
          viewBox="0 0 120 120"
          className="form-input__icon form-input__icon-close"
          width="24"
          height="24"
          role="presentation"
        >
          <use xlinkHref="#close-regular" />
        </svg>
        <svg
          viewBox="0 0 20 20"
          className="form-input__icon form-input__icon-search"
          width="22"
          height="22"
          role="presentation"
        >
          <use xlinkHref="#search" />
        </svg>
      </div>
      {hasError ? (
        <p className="form-input__error">{props.errorMessage}</p>
      ) : (
        ''
      )}
    </div>
  );
}
